import { getLocale } from "../runtime";

const sv_easteregg5 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ett ögonblick av lugn i en hektisk dag. Vi får dig på rätt spår snart.`
};

const easteregg5 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_easteregg5(inputs)
	return "easterEgg5";
};

export { easteregg5 as "easterEgg5" };